import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import defaultImage from "../../../utils/DefaultImage";
import TableLoader from "../../../utils/TableLoader";
import SearchInput from "../../../utils/SearchInput";
import PaginationComponent from "../../../utils/PaginationComponent";

const StockView = () => {

  const { slug2, rest_slug2 } = useParams();
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [searchText, setSearchText] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [restaurentDetail, setRestaurentDetail] = useState();
  const [stockData, setStockData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearchChange = (value) => {
    setSearchText(value);
  };

  //Dialog Box For Confirmation
  // const [dialog1, setDialog1] = useState(false);

  // Fetch Stock Data
  const getWineData = async () => {
    setIsLoading(true);
    try {
      let params;
      if (searchText) {
        params = {
          pageNumber: page,
          size: rowsPerPage,
          search: searchText,
        };
      } else {
        params = {
          pageNumber: page,
          size: rowsPerPage,
        };
      }
      const response = await axios.get(
        `${apiUrl}/api/v1/wine-stock/${slug2 ? slug2 : rest_slug2}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response?.data;
      setStockData(data?.data);
      setTotalPages(data?.total);
    } catch (error) {
      console.error("Error fetching wine data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getRestData = async () => {
    axios
      .get(`${apiUrl}/api/v1/restaurants/${slug2 ? slug2 : rest_slug2}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setRestaurentDetail(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching restaurant data:", err);
      });
  };

  // const wineStockDelete = async (id) => {
  //   console.log("id", id);
  //   setIsLoading(true);

  //   // Get token from localStorage
  //   const token = localStorage.getItem("token");

  //   try {
  //     const apiUrl = `${import.meta.env.VITE_METERI_API_BASE_URL}/api/v1/winstock/${id}`;
  //     await axios.delete(apiUrl, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //   } catch (err) {
  //     console.error("Error deleting wine list:", err);
  //   } finally {
  //     // await getWineListData();
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    getWineData();
  }, [page, rowsPerPage, searchText]);

  useEffect(() => {
    getRestData();
  }, [slug2, rest_slug2]);

  return (
    <>
      <section className="border-t border-[#D9D9D9] md:mt-5 md:pt-10 pt-5">
        <div className="flex md:flex-row flex-col gap-4 justify-between items-center">
          <h3 className="md:text-3xl text-2xl self-start font-bold poppins-medium">
            La Cantina di{" "}
            {restaurentDetail?.company_name
              ? restaurentDetail?.company_name
              : "-"}
          </h3>
          <div className="self-start flex sm:flex-row flex-col sm:w-auto w-full">
            <SearchInput
              onSearchChange={handleSearchChange}
              component="Wine Stock"
              placeholder="nella tua cantina"
            />
          </div>
        </div>
        <div className="md:mt-5 mt-2 flex flex-col gap-2">
          <div className="wine-main-stock w-full flex  gap-3 items-start mb-2 justify-start py-3 flex-wrap">
            <table className="w-full text-left wine_table">
              <thead>
                <tr className="border-b border-[#8B2433]">
                  <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">
                    Immagine
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Nome
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Tipologia
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Nazione
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Prezzo
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Quantità
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Prezzo totale
                  </th>
                  {/* <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Opzioni</th> */}
                </tr>
              </thead>
              {isLoading ? (
                <TableLoader />
              ) : (
                <tbody>
                  {Array?.isArray(stockData) && stockData?.length > 0 ? (
                    stockData?.map((wine, index) => (
                      <tr
                        key={index}
                        className="border-b border-[#8B2433]/12"
                      >
                        <td className="pr-2 py-4">
                          <div className="thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center">
                            <img
                              className="w-100 p-1 h-100 object-contain border border-[#68172394] rounded-lg"
                              src={
                                wine?.wine?.image && wine?.wine?.image !== ""
                                  ? wine?.wine?.image
                                  : defaultImage
                              }
                              height={50}
                              width={50}
                            />
                          </div>
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {wine?.wine?.name || "N/A"}
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {wine?.wine?.product_type || "N/A"}
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {wine?.wine?.nation || "N/A"}
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {wine?.price === null || wine?.price === "0.00"
                            ? wine?.wine?.meta?.[0]?.b2b_price
                              ? `${wine?.wine?.meta?.[0]?.b2b_price} €`
                              : "0.00"
                            : `${wine?.price} €`}

                          {/* {wine?.wine?.b2b_price === null &&
                            wine?.wine?.b2b_price === 0.0
                              ? `${wine?.wine?.b2b_price} €`
                              : wine?.wine?.meta?.[0]?.b2b_price
                              ? `${wine?.wine?.meta?.[0]?.b2b_price} €`
                              : "0.00"} */}
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                            {/* {wine?.bottles_quantity === null || wine?.bottles_quantity === 0 */}
                            {/* // ? wine?.wine?.meta?.[0]?.quantity ?? "0" */}
                            {/* // : wine?.bottles_quantity} */}
                            {wine?.bottles_quantity ? wine?.bottles_quantity : "0"}
                          </span>
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {wine?.price !== null && wine?.price !== "0.00"
                            ? `${(
                              (parseFloat(wine?.price) || 0) *
                              (wine?.bottles_quantity === null || wine?.bottles_quantity === 0
                                ? wine?.wine?.meta?.[0]?.quantity ?? 0
                                : wine?.bottles_quantity)
                            ).toFixed(2)} €`
                            : wine?.wine?.meta?.[0]?.b2b_price
                              ? `${(
                                (parseFloat(wine?.wine?.meta?.[0]?.b2b_price) || 0) *
                                (wine?.bottles_quantity === null || wine?.bottles_quantity === 0
                                  ? wine?.wine?.meta?.[0]?.quantity ?? 0
                                  : wine?.bottles_quantity)
                              ).toFixed(2)} €`
                              : "0.00"}
                        </td>
                        {/* <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                            <MdDelete className="text-xl cursor-pointer"
                              onClick={() => setDialog1(true)} />
                            {dialog1 && (
                              <div className="fixed inset-0 flex items-center justify-center bg-opacity-50 backdrop-blur-sm z-50">
                                <div className="bg-white rounded-lg border-[2px] w-1/3">
                                  <div className="px-6 py-4 border-b">
                                    <h1 className="text-xl font-semibold poppins-medium">Cancella Articolo</h1>
                                  </div>
                                  <div className="px-6 py-4 border-b">
                                    <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                      Sei sicuro di voler cancellare questo articolo dalla tua cantina?
                                    </h3>
                                  </div>
                                  <div className="px-6 py-4 flex justify-end space-x-4">
                                    <button
                                      onClick={() => { wineStockDelete(wine?.wine?.id); setDialog1(false); }}
                                      className="px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md hover:bg-[#f6efef] hover:text-[#8A2533] transition-colors"
                                    >
                                      Si
                                    </button>
                                    <button
                                      onClick={() => setDialog1(false)}
                                      className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center py-4">
                        Nessun vino trovato
                      </td>
                    </tr>
                  )}
                  {/* {/ Footer Row /} */}
                  <tr className="font-bold text-[#303030]">
                    <td
                      colSpan={6}
                      className="text-right py-4 px-2 poppins-medium"
                    >
                      Valore Cantina:
                    </td>
                    <td className="text-left py-4 px-2 poppins-medium">
                      <td>
                        {Array.isArray(stockData)
                          ? (() => {
                            const totalSum = stockData.reduce((sum, wine) => {
                              const price =
                                wine?.price !== null && wine?.price !== "0.00"
                                  ? parseFloat(wine?.price) || 0
                                  : parseFloat(wine?.wine?.meta?.[0]?.b2b_price) || 0;
                              const quantity =
                                wine?.bottles_quantity === null || wine?.bottles_quantity === 0
                                  ? wine?.wine?.meta?.[0]?.quantity ?? 0
                                  : wine?.bottles_quantity;
                              return sum + price * quantity;
                            }, 0);
                            // console.log("Total Sum:", totalSum);
                            return `${totalSum.toFixed(2)} €`;
                          })()
                          : "0.00 €"}
                      </td>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
        {stockData && stockData?.length > 0 && (
          <PaginationComponent
            page={page}
            totalPages={totalPages}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
          />
        )}
      </section>
    </>
  );
};

export default StockView;
